import React, { useState, useEffect, useRef } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useSpeakAnswer } from '../../lib/useSpeakAnswer';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import './SyllableStructure.css';

const WORDS_BY_AGE = {
  '4': [
    {
      id: 'vata', 
      word: 'Вата', 
      syllables: ['ВА', 'ТА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, // <--- ЗАКРЫВАЕМ ПЕРВОЕ СЛОВО И СТАВИМ ЗАПЯТУЮ

{
      id: 'noty', 
      word: 'Ноты', 
      syllables: ['НО', 'ТЫ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/noty.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/noty_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/noty_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, 

{
      id: 'lapa', 
      word: 'Лапа', 
      syllables: ['ЛА', 'ПА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, 

   {
      id: 'seno', 
      word: 'Сено', 
      syllables: ['СЕ', 'НО'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/seno.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/seno_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/seno_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'owl', // <--- ИСПРАВИЛИ ID НА owl
      word: 'Сова', 
      syllables: ['СО', 'ВА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/owl.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/owl_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/owl_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'panama', 
      word: 'Панама', 
      syllables: ['ПА', 'НА', 'МА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'batony', 
      word: 'Батоны', 
      syllables: ['БА', 'ТО', 'НЫ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'banany', 
      word: 'Бананы', 
      syllables: ['БА', 'НА', 'НЫ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banany.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banany_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banany_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banany_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    } // <--- ЗАКРЫВАЕМ ВТОРОЕ СЛОВО (запятая не нужна, так как это последнее слово в списке)
  ],
 
  '5': [

{
      id: 'vata', 
      word: 'Вата', 
      syllables: ['ВА', 'ТА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, // <--- ЗАКРЫВАЕМ ПЕРВОЕ СЛОВО И СТАВИМ ЗАПЯТУЮ

{
      id: 'lapa', 
      word: 'Лапа', 
      syllables: ['ЛА', 'ПА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, 

{
      id: 'batony', 
      word: 'Батоны', 
      syllables: ['БА', 'ТО', 'НЫ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

        {
      id: 'panama', 
      word: 'Панама', 
      syllables: ['ПА', 'НА', 'МА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'buton', 
      word: 'Бутон', 
      syllables: ['БУ', 'ТОН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'penal', 
      word: 'Пенал', 
      syllables: ['ПЕ', 'НАЛ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'banka', 
      word: 'Банка', 
      syllables: ['БАН', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'gaika', 
      word: 'Гайка', 
      syllables: ['ГАЙ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'pavlin', 
      word: 'Павлин', 
      syllables: ['ПАВ', 'ЛИН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'tyulpan', 
      word: 'Тюльпан', 
      syllables: ['ТЮЛЬ', 'ПАН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },
    
     {
      id: 'botinki', 
      word: 'Ботинки', 
      syllables: ['БО', 'ТИН', 'КИ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'kalitka', 
      word: 'Калитка', 
      syllables: ['КА', 'ЛИТ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    ],

  '6': [
    
{
      id: 'vata', 
      word: 'Вата', 
      syllables: ['ВА', 'ТА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, // <--- ЗАКРЫВАЕМ ПЕРВОЕ СЛОВО И СТАВИМ ЗАПЯТУЮ

{
      id: 'lapa', 
      word: 'Лапа', 
      syllables: ['ЛА', 'ПА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, 

{
      id: 'batony', 
      word: 'Батоны', 
      syllables: ['БА', 'ТО', 'НЫ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

        {
      id: 'panama', 
      word: 'Панама', 
      syllables: ['ПА', 'НА', 'МА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'buton', 
      word: 'Бутон', 
      syllables: ['БУ', 'ТОН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'penal', 
      word: 'Пенал', 
      syllables: ['ПЕ', 'НАЛ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'banka', 
      word: 'Банка', 
      syllables: ['БАН', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'gaika', 
      word: 'Гайка', 
      syllables: ['ГАЙ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'pavlin', 
      word: 'Павлин', 
      syllables: ['ПАВ', 'ЛИН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'tyulpan', 
      word: 'Тюльпан', 
      syllables: ['ТЮЛЬ', 'ПАН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },
    
     {
      id: 'botinki', 
      word: 'Ботинки', 
      syllables: ['БО', 'ТИН', 'КИ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'kalitka', 
      word: 'Калитка', 
      syllables: ['КА', 'ЛИТ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    ],

  '7': [
    
{
      id: 'vata', 
      word: 'Вата', 
      syllables: ['ВА', 'ТА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, // <--- ЗАКРЫВАЕМ ПЕРВОЕ СЛОВО И СТАВИМ ЗАПЯТУЮ

{
      id: 'lapa', 
      word: 'Лапа', 
      syllables: ['ЛА', 'ПА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, 

{
      id: 'batony', 
      word: 'Батоны', 
      syllables: ['БА', 'ТО', 'НЫ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

        {
      id: 'panama', 
      word: 'Панама', 
      syllables: ['ПА', 'НА', 'МА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'buton', 
      word: 'Бутон', 
      syllables: ['БУ', 'ТОН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'penal', 
      word: 'Пенал', 
      syllables: ['ПЕ', 'НАЛ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'banka', 
      word: 'Банка', 
      syllables: ['БАН', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'gaika', 
      word: 'Гайка', 
      syllables: ['ГАЙ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'pavlin', 
      word: 'Павлин', 
      syllables: ['ПАВ', 'ЛИН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'tyulpan', 
      word: 'Тюльпан', 
      syllables: ['ТЮЛЬ', 'ПАН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },
    
     {
      id: 'botinki', 
      word: 'Ботинки', 
      syllables: ['БО', 'ТИН', 'КИ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'kalitka', 
      word: 'Калитка', 
      syllables: ['КА', 'ЛИТ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    ],

  '8': [
    
{
      id: 'vata', 
      word: 'Вата', 
      syllables: ['ВА', 'ТА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/vata_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, // <--- ЗАКРЫВАЕМ ПЕРВОЕ СЛОВО И СТАВИМ ЗАПЯТУЮ

{
      id: 'lapa', 
      word: 'Лапа', 
      syllables: ['ЛА', 'ПА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/lapa_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    }, 

{
      id: 'batony', 
      word: 'Батоны', 
      syllables: ['БА', 'ТО', 'НЫ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/batony_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

        {
      id: 'panama', 
      word: 'Панама', 
      syllables: ['ПА', 'НА', 'МА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/panama_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'buton', 
      word: 'Бутон', 
      syllables: ['БУ', 'ТОН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/buton_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    {
      id: 'penal', 
      word: 'Пенал', 
      syllables: ['ПЕ', 'НАЛ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/penal_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'banka', 
      word: 'Банка', 
      syllables: ['БАН', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/banka_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'gaika', 
      word: 'Гайка', 
      syllables: ['ГАЙ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/gaika_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'pavlin', 
      word: 'Павлин', 
      syllables: ['ПАВ', 'ЛИН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/pavlin_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'tyulpan', 
      word: 'Тюльпан', 
      syllables: ['ТЮЛЬ', 'ПАН'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/tyulpan_2.png'
      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },
    
     {
      id: 'botinki', 
      word: 'Ботинки', 
      syllables: ['БО', 'ТИН', 'КИ'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/botinki_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

{
      id: 'kalitka', 
      word: 'Калитка', 
      syllables: ['КА', 'ЛИТ', 'КА'], 
      fullImg: 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka.png',
      parts: [
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_1.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_2.png',
        'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/puzzles/kalitka_3.png',

      ] // <--- ЗАКРЫВАЕМ МАССИВ КАРТИНОК
    },

    ],


  '9': [], '10-12': [], '13-15': [], '16+': []




};

// A word's repetition counts as correct if enough of its syllables were —
// not necessarily all of them, for longer words. Allowed wrong syllables:
// 2-syllable word -> 0 (all must be right), 3 -> 1, 4 -> 1, 5 -> 2.
// That's floor((n-1)/2) wrong syllables tolerated for an n-syllable word.
const getMinCorrectSyllables = (totalSyllables) => {
  const allowedWrong = Math.floor((totalSyllables - 1) / 2);
  return totalSyllables - allowedWrong;
};

const SyllableStructure = ({ ageGroup, onBack, onComplete }) => {
  const { start: startSpeakRecognition, stop: stopSpeakRecognition } = useSpeakAnswer('SyllableStructure');
  const { play: playInstruction, stop: stopInstruction } = useInstructionAudio();
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [phase, setPhase] = useState('intro');
  const [currentSyllableIndex, setCurrentSyllableIndex] = useState(0);
  const [syllableResults, setSyllableResults] = useState([]);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);

  const hasCompletedRef = useRef(false);
  // The recognizer for a word is started once and kept running across all of
  // that word's syllables (same grammar the whole time), so onResult is a
  // long-lived closure — it needs a ref, not the currentSyllableIndex state,
  // to know which syllable is currently expected.
  const currentSyllableIndexRef = useRef(0);
  // Guards against a stray recognition event landing after the word's last
  // syllable was already answered but before the per-word effect's cleanup
  // has torn the recognizer down (e.g. during the 'merged' animation).
  const expectingSyllableRef = useRef(false);

  const words = WORDS_BY_AGE[ageGroup] || WORDS_BY_AGE['4'];
  const currentWord = words[currentWordIndex];
  const totalQuestions = words.length;

  const speak = (text, onEndCallback) => {
    setIsSpeaking(true);
    playInstruction(text, () => {
      setIsSpeaking(false);
      if (onEndCallback) onEndCallback();
    });
  };

  const handleSyllableResult = (result) => {
    const syllableIndex = currentSyllableIndexRef.current;
    setSyllableResults(prev => {
      const next = [...prev];
      next[syllableIndex] = result;
      return next;
    });

    setTimeout(() => {
      const nextIndex = syllableIndex + 1;
      if (nextIndex < currentWord.syllables.length) {
        currentSyllableIndexRef.current = nextIndex;
        setCurrentSyllableIndex(nextIndex);
        expectingSyllableRef.current = true;
      } else {
        expectingSyllableRef.current = false;
        stopSpeakRecognition();
        setPhase('merged');
      }
    }, 800);
  };

  // One recognizer per word, started immediately (grammar first) alongside —
  // not after — the intro voiceover, so it's already warmed up by the time
  // the child can respond instead of missing the first syllable while a
  // fresh Kaldi grammar is still being estimated. It keeps listening
  // continuously through every syllable of the word (grammar never changes
  // within a word), instead of being torn down and rebuilt with the exact
  // same candidate list after each syllable.
  useEffect(() => {
    if (!currentWord || showResult) return;

    currentSyllableIndexRef.current = 0;
    expectingSyllableRef.current = true;

    const candidates = currentWord.syllables.map((syllable, index) => ({
      key: `syllable-${index}`,
      text: syllable,
    }));

    startSpeakRecognition(candidates, {
      continuous: true,
      timeoutMs: Math.max(15000, currentWord.syllables.length * 7000),
      onListening: () => setIsListening(true),
      onResult: ({ matchedKey, timedOut }) => {
        if (!expectingSyllableRef.current) return;
        // Lock out immediately, before handling this result: the Kaldi
        // engine sometimes fires two near-identical raw 'result' events for
        // the same utterance (visible as back-to-back duplicate "heard: X"
        // log lines). Without this lock, a duplicate for the syllable that
        // was just answered still passes this guard (currentSyllableIndexRef
        // hasn't advanced yet — that only happens 800ms later in
        // handleSyllableResult) and fires a second, overlapping
        // handleSyllableResult call whose delayed stopSpeakRecognition() can
        // land after the exercise has already moved on to the next word.
        expectingSyllableRef.current = false;
        if (timedOut) {
          setIsListening(false);
          handleSyllableResult('wrong');
          return;
        }
        const isCorrect = matchedKey === `syllable-${currentSyllableIndexRef.current}`;
        handleSyllableResult(isCorrect ? 'correct' : 'wrong');
      },
    });

    speak(currentWord.word, () => setPhase('split'));

    return () => {
      expectingSyllableRef.current = false;
      stopSpeakRecognition();
      stopInstruction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWordIndex, showResult]);

   useEffect(() => {
    if (!currentWord || showResult) return;

    let timer; // Сохраняем ID таймера

    if (phase === 'merged') {
      timer = setTimeout(() => {
        const correctCount = syllableResults.filter(r => r === 'correct').length;
        const isWordCorrect = correctCount >= getMinCorrectSyllables(currentWord.syllables.length);
        setAnswers(prev => [...prev, isWordCorrect]);
        setSyllableResults([]);
        setCurrentSyllableIndex(0);
        setPhase('intro');

        if (currentWordIndex < totalQuestions - 1) {
          setCurrentWordIndex(prev => prev + 1);
        } else {
          setShowResult(true);
        }
      }, 2000);
    }

    // ФУНКЦИЯ ОЧИСТКИ: отменит таймер, если компонент перерисовался или скрылся
    return () => {
      clearTimeout(timer);
      stopInstruction(); // На всякий случай прерываем речь
    };
  }, [phase, currentWordIndex, currentSyllableIndex, showResult]);
  
  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => {
        if (!hasCompletedRef.current) {
          hasCompletedRef.current = true;
          if (onComplete) {
            const correctCount = answers.filter(a => a === true).length;
            const score = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0;
            onComplete({ testId: 'SyllableStructure', score });
          } else { onBack(); }
        }
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showResult]);

  if (showResult) {
    const correctCount = answers.filter(a => a === true).length;
    return (
      <ModuleTemplate progress={answers} totalQuestions={totalQuestions} forceStop={true} onComplete={onComplete || onBack}>
        <div className="result-content">
          <h2 className="result-title">🎉 Упражнение завершено!</h2>
          <div className="result-score">
            <span className="score-number">{correctCount}</span>
            <span className="score-total"> / {totalQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  if (!currentWord) return (
    <ModuleTemplate progress={answers} totalQuestions={1} forceStop={true} onComplete={onComplete || onBack}>
      <div className="loading-text">Для этого возраста пока нет заданий</div>
    </ModuleTemplate>
  );

  return (
    <ModuleTemplate 
      progress={answers} 
      totalQuestions={totalQuestions} 
      forceStop={true}             
      onComplete={onComplete}      
    >
      <div className="syllable-container">
        
        <div className="syllable-indicators">
          <div className={`indicator listen ${isSpeaking ? 'active' : ''}`}><span className="indicator-icon">🎧</span></div>
          <div className={`indicator speak ${isListening ? 'active' : ''}`}><span className="indicator-icon">🗣️</span></div>
                  </div>

        <div className="syllable-image-box">
          
          <div className={`syllable-parts-wrapper ${phase === 'split' ? 'split' : ''}`}>
            {currentWord.parts.map((src, index) => (
              <div key={index} className="syllable-part">
                <img src={src} alt={currentWord.syllables[index]} />
              </div>
            ))}
          </div>

          <img 
            src={currentWord.fullImg} 
            className={`syllable-full-img ${phase === 'split' ? 'is-invisible' : ''} ${phase === 'merged' ? 'is-appearing' : ''}`} 
            alt={currentWord.word} 
          />

        </div>

        {/* ИЗМЕНЕНИЕ 3: Показываем слово целиком в начале и конце, слоги в середине */}
        <div className="syllable-hints">
          {phase === 'split' ? (
            currentWord.syllables.map((syl, index) => (
              <div key={index} className={`syllable-hint ${syllableResults[index] === 'correct' ? 'correct' : syllableResults[index] === 'wrong' ? 'wrong' : ''}`}>
                {syl}
              </div>
            ))
          ) : (
            <div className="syllable-hint whole-word">{currentWord.word}</div>
          )}
        </div>
      </div>
    </ModuleTemplate>
  );
};

export default SyllableStructure;